import { Route, Routes, useLocation } from "react-router-dom";

import { AnimatePresence } from "framer-motion";
import Auth from "./Auth";
import ChartsPage from "./ChartsPage";
import HomePage from "./HomePage";

const AnimatedRoutes = () => {
  const location = useLocation();
  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route path="/charts" element={<ChartsPage />} />
        <Route index element={<Auth />} />
        <Route path="/home" element={<HomePage />} />
      </Routes>
    </AnimatePresence>
  );
};

export default AnimatedRoutes;
